import React from 'react';
import { element } from 'prop-types';
import styles from './Dropdown-style.scss';

const DropdownBody = ({ children }) => {
    return <div className={styles.body}>{children}</div>;
};

DropdownBody.propTypes = {
    children: element.isRequired,
};

export default DropdownBody;
